import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import ConfigContext from '../../contexts/configContext'
import { InnerImageZoom } from 'react-inner-image-zoom'

const ZoomImage = ({
  aspectHeight,
  aspectWidth,
  className,
  id,
  label,
  src,
  ...props
}) => {
  const { mediaCDN, imageCropMode, imageGravity, imagePadColor } = useContext(ConfigContext)
  const gravity = imageCropMode === 'fill' ? imageGravity : 'center'
  const baseUrl = `${mediaCDN}/image/upload/ar_${aspectWidth}:${aspectHeight},b_${imagePadColor},c_${imageCropMode},g_${gravity},f_auto,q_auto:good,`

  return (
    <div
      id={id}
      className='ratio-container'
    >
      <div
        className='ratio-container--holder' style={{
          paddingBottom: `${(aspectHeight / aspectWidth * 100)}%`
        }}
      />
      <InnerImageZoom
        className={className}
        aspectHeight={240}
        aspectWidth={320}
        label={label}
        zoomPreload
        zoomSrc={`${mediaCDN}/image/upload/f_auto,q_auto:good,w_2048/${src}`}
        src={`${baseUrl}w_900/${src}`}
        {...props}
      />
    </div>
  )
}

ZoomImage.propTypes = {
  aspectHeight: PropTypes.number.isRequired,
  aspectWidth: PropTypes.number.isRequired,
  className: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
  src: PropTypes.string.isRequired
}

ZoomImage.defaultProps = {
  className: '',
  aspectHeight: 3,
  aspectWidth: 4,
  onClick: null
}

export default React.memo(ZoomImage)
